import React, { useEffect } from 'react';
import './AddClientPopup.css'

const AddClientPopup = ({ 
  newClient, 
  setNewClient, 
  onSave, 
  onCancel, 
  isEditing = false,
  title = 'Add New Client',
  saveButtonText = 'Add Client'
}) => {
  // Prevent background scrolling when popup is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  return (
    <div className="InvoiceForm__popup-overlay">
      <div className="InvoiceForm__popup">
        <div className="InvoiceForm__popup-header">
          <h3 className="InvoiceForm__popup-title">{title}</h3>
          <button
            type="button"
            onClick={onCancel}
            className="InvoiceForm__popup-close"
          >
            ×
          </button>
        </div>
        
        <div className="InvoiceForm__popup-content">
          <div className="InvoiceForm__field-group">
            <label className="InvoiceForm__label">Client Name *</label>
            <input 
              placeholder="Enter client name" 
              className="InvoiceForm__input" 
              value={newClient.name}
              onChange={(e) => setNewClient({ ...newClient, name: e.target.value })} 
            />
          </div>
          
          <div className="InvoiceForm__field-group">
            <label className="InvoiceForm__label">Email</label>
            <input 
              type="email"
              placeholder="Enter email address" 
              className="InvoiceForm__input" 
              value={newClient.email}
              onChange={(e) => setNewClient({ ...newClient, email: e.target.value })} 
            />
          </div>
          
          <div className="InvoiceForm__field-group">
            <label className="InvoiceForm__label">Company Name</label>
            <input 
              placeholder="Enter company name" 
              className="InvoiceForm__input" 
              value={newClient.company}
              onChange={(e) => setNewClient({ ...newClient, company: e.target.value })} 
            />
          </div>
          
          <div className="InvoiceForm__field-group">
            <label className="InvoiceForm__label">GST Number</label>
            <input 
              placeholder="Enter GST number" 
              className="InvoiceForm__input" 
              value={newClient.gst}
              onChange={(e) => setNewClient({ ...newClient, gst: e.target.value })} 
            />
          </div>
          
          <div className="InvoiceForm__field-group">
            <label className="InvoiceForm__label">Address</label>
            <textarea 
              placeholder="Enter complete address" 
              className="InvoiceForm__textarea" 
              value={newClient.address}
              onChange={(e) => setNewClient({ ...newClient, address: e.target.value })} 
            />
          </div>
        </div>
        
        <div className="InvoiceForm__popup-footer">
          <button
            type="button"
            onClick={onCancel}
            className="InvoiceForm__button InvoiceForm__button--cancel"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onSave}
            className="InvoiceForm__button InvoiceForm__button--save"
            disabled={!newClient.name.trim()}
          >
            {saveButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddClientPopup;
